module.exports = __webpack_public_path__ + "img/bobijo_bobocoin.gm.ed66893.png";